module.exports = __webpack_public_path__ + "img/introLogo09.82450ca1.png";